export default "__VITE_ASSET__B$UtMSs___"